<rid-word-snake
  class="h-dvh"
  [snakes]="[
    ['hand', 'granaat', 'appel', 'taart', 'doos'],
    ['bureau', 'stoel', 'poot'],
  ]"
  (finished)="$router.navigate(['/mechanics/morphemes'])"
/>
